module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "起效学年",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.jpXn),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "jpXn", $$v)
      },
      expression: "queryForm.jpXn"
    }
  }, _vm._l((_vm.year), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "专业名称",
      "clearable": ""
    },
    on: {
      "change": _vm.changeMajor
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.jpZydm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "jpZydm", $$v)
      },
      expression: "queryForm.jpZydm"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.jpShzt),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "jpShzt", $$v)
      },
      expression: "queryForm.jpShzt"
    }
  }, _vm._l((_vm.status), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 新建")]), _vm._v(" "), (_vm.ggkAuth != '0') ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.pubCourseConfig
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 公共课设置\n        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog('mduplicate')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-document-copy"
  }), _vm._v(" 批量复制\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 课程设置导出\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.downloading),
      expression: "downloading"
    }],
    attrs: {
      "element-loading-text": "导出中"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.handleCellStyle,
      "header-cell-style": {
        'background-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "fit:false": "",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.queryForm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.isShow) ? _c('el-table-column', {
    attrs: {
      "label": "编号",
      "prop": "jpBh",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "起效学年",
      "prop": "jpXn",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业名称（代码）",
      "prop": "fullName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国标专业名称（代码）",
      "prop": "standardName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学制",
      "prop": "institution",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "指定班级",
      "prop": "jpGlbjmc",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交状态",
      "prop": "jpTjzt",
      "formatter": _vm.submitStateFormatter,
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "jpShzt",
      "formatter": _vm.auditStateFormatter,
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "20%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.jpTjzt == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.jpTjzt == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.delRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.jpTjzt == '1' && scope.row.auditAuth == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.auditAuth == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.auditRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 审核\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.jpTjzt == '1' || scope.row.jpShzt != '') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showAuditList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        }), _vm._v(" 审核信息\n                    ")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.queryForm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建",
      "visible": _vm.createDialogVisivle,
      "width": "600px",
      "top": "200px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.createDialogVisivle = $event
      },
      "closed": _vm.closeCreateDialog
    }
  }, [_c('el-form', {
    ref: "createForm",
    attrs: {
      "model": _vm.createForm,
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.createFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "起效学年",
      "prop": "workYear"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择起效学年"
    },
    on: {
      "change": _vm.yearChange
    },
    model: {
      value: (_vm.createForm.workYear),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "workYear", $$v)
      },
      expression: "createForm.workYear"
    }
  }, _vm._l((_vm.year), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择专业",
      "filterable": ""
    },
    on: {
      "change": _vm.majorChange
    },
    model: {
      value: (_vm.createForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "majorCode", $$v)
      },
      expression: "createForm.majorCode"
    }
  }, _vm._l((_vm.majorComboOption), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学制",
      "prop": "learnYear"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.createForm.learnYear) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指定班级",
      "prop": "glbjbh"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择指定班级",
      "multiple": ""
    },
    model: {
      value: (_vm.createForm.glbjbh),
      callback: function($$v) {
        _vm.$set(_vm.createForm, "glbjbh", $$v)
      },
      expression: "createForm.glbjbh"
    }
  }, _vm._l((_vm.createClassInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createTeachingScheme
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.createDialogVisivle = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.schemeDialogTitle,
      "custom-class": "teachingSchemeSetDialog",
      "visible": _vm.schemeDialogVisivle,
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.schemeDialogVisivle = $event
      },
      "closed": _vm.closeSchemeDialog
    }
  }, [_c('div', {
    staticClass: "maskStyle",
    attrs: {
      "id": "loadingMask"
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("人才培养方案加载中，请稍候...")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.templetDownload
    }
  }, [_vm._v("教学进程表模板下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.importCAP()
      }
    }
  }, [_c('i', [_vm._v("教学进程表导入")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportCAP()
      }
    }
  }, [_c('i', [_vm._v("教学进程表导出")])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importButtonVisible),
      expression: "importButtonVisible"
    }],
    attrs: {
      "type": "success",
      "disabled": _vm.editDisableState
    },
    on: {
      "click": _vm.importPubCourse
    }
  }, [_vm._v("公共课导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.statisticCAP()
      }
    }
  }, [_c('i', [_vm._v("课程类型统计")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showDialog('sduplicate')
      }
    }
  }, [_vm._v("复制")]), _vm._v(" "), (_vm.auditState == '1') ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.changeRec
    }
  }, [_vm._v("变更教学进程")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollArea",
    style: (_vm.innerDialog)
  }, [_c('el-scrollbar', {
    ref: "elScrollbar",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "titles",
    staticStyle: {
      "text-align": "center",
      "height": "60px",
      "line-height": "60px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    人才培养方案\n                ")]), _vm._v(" "), _c('el-row', [_c('teaching-form', {
    key: _vm.timer,
    ref: "teachingForm",
    attrs: {
      "isEdit": _vm.isEdit,
      "editDisableState": _vm.editDisableState,
      "classInfo": _vm.classInfo
    },
    on: {
      "loadParams": _vm.loadParams
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('occupation-scope', {
    ref: "occupation",
    attrs: {
      "editDisableState": _vm.editDisableState
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('talent', {
    ref: "talent",
    attrs: {
      "editDisableState": _vm.editDisableState
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('teaching-weeks', {
    ref: "teachingWeeks",
    attrs: {
      "editDisableState": _vm.editDisableState,
      "xz": _vm.xz
    },
    on: {
      "transweeks": _vm.transweeks,
      "changeArrange": _vm.changeArrange
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('CAP', {
    ref: "CAP",
    attrs: {
      "courseComboInfo": _vm.courseComboInfo,
      "editDisableState": _vm.editDisableState,
      "xz": _vm.xz
    },
    on: {
      "changeEditRow": _vm.changeEditRow,
      "openWindow": _vm.openWindow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('teaching-arrangement', {
    ref: "arrangement",
    attrs: {
      "editDisableState": _vm.editDisableState
    },
    on: {
      "changeEditRow": _vm.changeEditRow
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('graduateRequire', {
    ref: "graduateRequire",
    attrs: {
      "editDisableState": _vm.editDisableState,
      "courseAttr": _vm.kcsxInfo,
      "etype": _vm.etype
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('comment', {
    ref: "comment",
    attrs: {
      "editDisableState": _vm.editDisableState,
      "filelist": _vm.filelist,
      "etype": _vm.etype
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveButtonVisible),
      expression: "saveButtonVisible"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting,
      "disabled": _vm.editDisableState
    },
    on: {
      "click": function($event) {
        return _vm.saveScheme('save')
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitButtonVisible),
      expression: "submitButtonVisible"
    }],
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting,
      "disabled": _vm.editDisableState
    },
    on: {
      "click": _vm.submitWapper
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditButtonVisible),
      expression: "auditButtonVisible"
    }],
    attrs: {
      "type": "danger",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.showAuditDialog
    }
  }, [_vm._v("审 核")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '教学进程表变更信息',
      "width": "1200px",
      "top": "90px",
      "visible": _vm.editSchemeDialogVisivle,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editSchemeDialogVisivle = $event
      },
      "closed": _vm.closeEditSchemeDialog
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addJxjc
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 添加教学进程")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.editJxjc
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(" 修改教学进程")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.delJxjc
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v(" 删除教学进程")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "editSchemeTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.editSchemeData,
      "cell-style": _vm.handleCellStyle_jxjc,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.editSchemeTableHeight
    },
    on: {
      "row-click": _vm.rowClick_editScheme
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage_editScheme - 1) * _vm.limit_editScheme + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年",
      "prop": "jjXn",
      "align": "center",
      "min-width": "6%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业",
      "prop": "jjZymc",
      "align": "center",
      "min-width": "25%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程代码",
      "prop": "jjKcdm",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "jjKcmc",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "变更类型",
      "prop": "jjBglxmc",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交状态",
      "prop": "jjTjzt",
      "formatter": _vm.submitStateFormatter_editscheme,
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.jjTjzt == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.modRec_jxjc(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.jjTjzt == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.delRec_jxjc(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.jjTjzt == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showRec_jxjc(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                    ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage_editScheme,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit_editScheme,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total_editScheme
    },
    on: {
      "size-change": _vm.handleSizeChange_editScheme,
      "current-change": _vm.handlePageChange_editScheme,
      "update:currentPage": function($event) {
        _vm.currentPage_editScheme = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage_editScheme = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.jxjcTitle,
      "visible": _vm.jxjcDialogVisible,
      "width": "1662px",
      "top": _vm.jxjcHeight,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.jxjcDialogVisible = $event
      },
      "closed": _vm.closeJxjcDialog
    }
  }, [_c('el-form', {
    ref: "jxjcForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "model": _vm.jxjcForm,
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年",
      "prop": "jjXn"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.jxjcForm.jjXn + '学年') + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "jjZymc"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.jxjcForm.jjZymc) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [((_vm.jxjcTitle == '修改教学进程' || _vm.jxjcTitle == '删除教学进程') && _vm.jxjcForm.saveType != 'show') ? _c('el-form-item', {
    attrs: {
      "label": "原课程",
      "prop": "jjJxjckcmc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请选择原课程"
    },
    on: {
      "focus": _vm.openScheme
    },
    model: {
      value: (_vm.jxjcForm.jjJxjckcmc),
      callback: function($$v) {
        _vm.$set(_vm.jxjcForm, "jjJxjckcmc", $$v)
      },
      expression: "jxjcForm.jjJxjckcmc"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.jxjcForm.jjBglx != '1' && _vm.jxjcForm.saveType == 'show') ? _c('el-form-item', {
    attrs: {
      "label": "原课程",
      "prop": "jjJxjckcmc"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.jxjcForm.jjJxjckcmc) + "\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.jxjcTitle == '修改教学进程' || _vm.jxjcTitle == '删除教学进程') ? _c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原课程信息:"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "jjKcsx"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKclxmc))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程性质",
      "prop": "jjKcsx"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKcsxmc))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "jjKcdm"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKcmc))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jxjcTitle == '修改教学进程' || _vm.jxjcTitle == '删除教学进程') ? _c('el-row', [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "1622px"
    },
    attrs: {
      "data": _vm.oldJxjcForm,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "137px",
      "row-style": {
        'height': '64px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "70",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXf))])]
      }
    }], null, false, 1659392600)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "70",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjZxs))])]
      }
    }], null, false, 1873725143)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '理论\n教学',
      "width": "70",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjLljx))])]
      }
    }], null, false, 3013681812)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '实验\n实训',
      "width": "70",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjSysx))])]
      }
    }], null, false, 2287259591)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否专业\n核心课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isMajorcoreName))])]
      }
    }], null, false, 4200607899)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否考证\n课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isCertificateName))])]
      }
    }], null, false, 3945256334)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjKhfsmc))])]
      }
    }], null, false, 3354910110)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq1, scope.row.jjZs1)))])]
      }
    }], null, false, 1640239325)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq2, scope.row.jjZs2)))])]
      }
    }], null, false, 795789949)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq3, scope.row.jjZs3)))])]
      }
    }], null, false, 3232757789)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "四",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq4, scope.row.jjZs4)))])]
      }
    }], null, false, 109898941)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq5, scope.row.jjZs5)))])]
      }
    }], null, false, 794447453)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "六",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq6, scope.row.jjZs6)))])]
      }
    }], null, false, 4244965373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "七",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq7, scope.row.jjZs7)))])]
      }
    }], null, false, 2386965917)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "八",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq8, scope.row.jjZs8)))])]
      }
    }], null, false, 3274813501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "九",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq9, scope.row.jjZs9)))])]
      }
    }], null, false, 3959362013)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "十",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq10, scope.row.jjZs10)))])]
      }
    }], null, false, 4013568861)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjBz))])]
      }
    }], null, false, 4172767646)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jxjcTitle == '添加教学进程' || _vm.jxjcTitle == '修改教学进程') ? _c('el-row', {
    staticClass: "elrowStyle"
  }, [(_vm.jxjcTitle == '修改教学进程') ? _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新课程信息:"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "jjKclx"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择课程类别",
      "filterable": ""
    },
    on: {
      "change": _vm.coursePropertiesChange
    },
    model: {
      value: (_vm.editJxjcForm[0].jjKclx),
      callback: function($$v) {
        _vm.$set(_vm.editJxjcForm[0], "jjKclx", $$v)
      },
      expression: "editJxjcForm[0].jjKclx"
    }
  }, _vm._l((_vm.kclxInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.editJxjcForm[0].jjKclxmc))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程性质",
      "prop": "jjKcsx"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": _vm.kcsxholder,
      "disabled": _vm.kcsxDisabled,
      "filterable": ""
    },
    model: {
      value: (_vm.editJxjcForm[0].jjKcsx),
      callback: function($$v) {
        _vm.$set(_vm.editJxjcForm[0], "jjKcsx", $$v)
      },
      expression: "editJxjcForm[0].jjKcsx"
    }
  }, _vm._l((_vm.kcsxInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.editJxjcForm[0].jjKcsxmc))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "jjKcdm"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择课程",
      "filterable": ""
    },
    on: {
      "change": _vm.courseInfoChange
    },
    model: {
      value: (_vm.editJxjcForm[0].jjKcdm),
      callback: function($$v) {
        _vm.$set(_vm.editJxjcForm[0], "jjKcdm", $$v)
      },
      expression: "editJxjcForm[0].jjKcdm"
    }
  }, _vm._l((_vm.courseInfo), function(item, index) {
    return _c('el-option', {
      key: item.jjKcdm,
      attrs: {
        "label": item.courseName,
        "value": item.jjKcdm
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.editJxjcForm[0].jjKcmc))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jxjcTitle == '添加教学进程' || _vm.jxjcTitle == '修改教学进程') ? _c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "1622px"
    },
    attrs: {
      "data": _vm.editJxjcForm,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "183px",
      "row-style": {
        'height': '64px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "70",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input-number', {
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "controls": false,
            "size": "mini",
            "min": 0
          },
          model: {
            value: (scope.row.jjXf),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXf", $$v)
            },
            expression: "scope.row.jjXf"
          }
        })], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjXf))])]
      }
    }], null, false, 4094457534)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "70",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input-number', {
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "controls": false,
            "size": "mini",
            "min": 0
          },
          model: {
            value: (scope.row.jjZxs),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZxs", $$v)
            },
            expression: "scope.row.jjZxs"
          }
        })], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjZxs))])]
      }
    }], null, false, 568766462)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '理论\n教学',
      "width": "70",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input-number', {
          staticClass: "numbers",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "controls-position": "right",
            "max": 1000,
            "size": "mini",
            "step": 1,
            "step-strictly": true,
            "min": 0,
            "controls": false
          },
          model: {
            value: (scope.row.jjLljx),
            callback: function($$v) {
              _vm.$set(scope.row, "jjLljx", _vm._n($$v))
            },
            expression: "scope.row.jjLljx"
          }
        })], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjLljx))])]
      }
    }], null, false, 2035444767)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '实验\n实训',
      "width": "70",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input-number', {
          staticClass: "numbers",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "controls-position": "right",
            "max": 1000,
            "size": "mini",
            "step": 1,
            "min": 0,
            "step-strictly": true,
            "controls": false
          },
          model: {
            value: (scope.row.jjSysx),
            callback: function($$v) {
              _vm.$set(scope.row, "jjSysx", _vm._n($$v))
            },
            expression: "scope.row.jjSysx"
          }
        })], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjSysx))])]
      }
    }], null, false, 938801151)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否专业\n核心课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.handleMajorcoreChange(scope)
            }
          },
          model: {
            value: (scope.row.isMajorcore),
            callback: function($$v) {
              _vm.$set(scope.row, "isMajorcore", $$v)
            },
            expression: "scope.row.isMajorcore"
          }
        }, _vm._l((_vm.sfzt), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.isMajorcore))])]
      }
    }], null, false, 1061794328)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否考证\n课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.handleCertificateChange(scope)
            }
          },
          model: {
            value: (scope.row.isCertificate),
            callback: function($$v) {
              _vm.$set(scope.row, "isCertificate", $$v)
            },
            expression: "scope.row.isCertificate"
          }
        }, _vm._l((_vm.sfzt), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.isCertificate))])]
      }
    }], null, false, 3803466477)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-select', {
          attrs: {
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.handleExamTypeChange(scope)
            }
          },
          model: {
            value: (scope.row.jjKhfs),
            callback: function($$v) {
              _vm.$set(scope.row, "jjKhfs", $$v)
            },
            expression: "scope.row.jjKhfs"
          }
        }, _vm._l((_vm.assessFormInfo), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjKhfsmc))])]
      }
    }], null, false, 3474036632)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq1),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq1", $$v)
            },
            expression: "scope.row.jjXq1"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs1),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs1", $$v)
            },
            expression: "scope.row.jjZs1"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq1, scope.row.jjZs1)))])]
      }
    }], null, false, 4005361608)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq2),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq2", $$v)
            },
            expression: "scope.row.jjXq2"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs2),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs2", $$v)
            },
            expression: "scope.row.jjZs2"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq2, scope.row.jjZs2)))])]
      }
    }], null, false, 3836647624)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq3),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq3", $$v)
            },
            expression: "scope.row.jjXq3"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs3),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs3", $$v)
            },
            expression: "scope.row.jjZs3"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq3, scope.row.jjZs3)))])]
      }
    }], null, false, 569708872)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "四",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq4),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq4", $$v)
            },
            expression: "scope.row.jjXq4"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs4),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs4", $$v)
            },
            expression: "scope.row.jjZs4"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq4, scope.row.jjZs4)))])]
      }
    }], null, false, 2084022856)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq5),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq5", $$v)
            },
            expression: "scope.row.jjXq5"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs5),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs5", $$v)
            },
            expression: "scope.row.jjZs5"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq5, scope.row.jjZs5)))])]
      }
    }], null, false, 2843562184)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "六",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq6),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq6", $$v)
            },
            expression: "scope.row.jjXq6"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs6),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs6", $$v)
            },
            expression: "scope.row.jjZs6"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq6, scope.row.jjZs6)))])]
      }
    }], null, false, 1293009352)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "七",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq7),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq7", $$v)
            },
            expression: "scope.row.jjXq7"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs7),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs7", $$v)
            },
            expression: "scope.row.jjZs7"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq7, scope.row.jjZs7)))])]
      }
    }], null, false, 1080820296)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "八",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq8),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq8", $$v)
            },
            expression: "scope.row.jjXq8"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs8),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs8", $$v)
            },
            expression: "scope.row.jjZs8"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq8, scope.row.jjZs8)))])]
      }
    }], null, false, 4031091528)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "九",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq9),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq9", $$v)
            },
            expression: "scope.row.jjXq9"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs9),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs9", $$v)
            },
            expression: "scope.row.jjZs9"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq9, scope.row.jjZs9)))])]
      }
    }], null, false, 1931672008)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "十",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          staticStyle: {
            "width": "90px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjXq10),
            callback: function($$v) {
              _vm.$set(scope.row, "jjXq10", $$v)
            },
            expression: "scope.row.jjXq10"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("学时")])], 2), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "width": "90px",
            "margin-top": "5px"
          },
          attrs: {
            "maxlength": "100",
            "oninput": "value=value.replace(/[^\\d]/g,'')"
          },
          model: {
            value: (scope.row.jjZs10),
            callback: function($$v) {
              _vm.$set(scope.row, "jjZs10", $$v)
            },
            expression: "scope.row.jjZs10"
          }
        }, [_c('template', {
          staticStyle: {
            "padding": "0px"
          },
          slot: "append"
        }, [_vm._v("周")])], 2)], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq10, scope.row.jjZs10)))])]
      }
    }], null, false, 2260612936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow != 'show'),
            expression: "this.jxjcShow != 'show'"
          }],
          staticClass: "el-edit"
        }, [_c('el-input', {
          attrs: {
            "placeholder": ""
          },
          model: {
            value: (scope.row.bz),
            callback: function($$v) {
              _vm.$set(scope.row, "bz", $$v)
            },
            expression: "scope.row.bz"
          }
        })], 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (this.jxjcShow == 'show'),
            expression: "this.jxjcShow == 'show'"
          }]
        }, [_vm._v(_vm._s(scope.row.jjBz))])]
      }
    }], null, false, 966146280)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.editJxjcForm[0].saveType == 'new' || _vm.editJxjcForm[0].saveType == 'edit') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.saveJxjcbg('save')
      }
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.editJxjcForm[0].saveType == 'new' || _vm.editJxjcForm[0].saveType == 'edit') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.submitJxjcbg
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.editJxjcForm[0].saveType == 'audit') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.auditOption();
      }
    }
  }, [_vm._v("审 核")]) : _vm._e(), _vm._v(" "), (_vm.editJxjcForm[0].saveType != 'show') ? _c('el-button', {
    on: {
      "click": _vm.closeJxjcDialog
    }
  }, [_vm._v("取 消")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.jxjcTitle,
      "visible": _vm.jxjcCompareDialogVisible,
      "width": "1662px",
      "top": "80px",
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.jxjcCompareDialogVisible = $event
      },
      "closed": _vm.closeCompareJxjcDialog
    }
  }, [_c('el-form', {
    ref: "jxjcForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "model": _vm.jxjcForm,
      "rules": _vm.jxjcRule,
      "label-position": "left",
      "label-width": "100px"
    }
  }, [_c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年",
      "prop": "jjXn"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.jxjcForm.jjXn + '学年') + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "jjZymc"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.jxjcForm.jjZymc) + "\n                    ")])], 1)], 1), _vm._v(" "), (_vm.jxjcForm.jjBglx == '2') ? _c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原课程信息:"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "jjKcsx"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKclxmc))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程性质",
      "prop": "jjKcsx"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKcsxmc))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "jjKcdm"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.oldJxjcForm[0].jjKcmc))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.jxjcForm.jjBglx == '2') ? _c('el-row', [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "1622px"
    },
    attrs: {
      "data": _vm.oldJxjcForm,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "137px",
      "row-style": {
        'height': '64px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "70",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXf))])]
      }
    }], null, false, 1659392600)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "70",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjZxs))])]
      }
    }], null, false, 1873725143)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "理论教学",
      "width": "70",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjLljx))])]
      }
    }], null, false, 3013681812)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实验实训",
      "width": "70",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjSysx))])]
      }
    }], null, false, 2287259591)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否专业\n核心课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isMajorcore))])]
      }
    }], null, false, 1198580028)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否考证\n课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isCertificate))])]
      }
    }], null, false, 2273728169)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjKhfsmc))])]
      }
    }], null, false, 3354910110)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq1, scope.row.jjZs1)))])]
      }
    }], null, false, 1640239325)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq2, scope.row.jjZs2)))])]
      }
    }], null, false, 795789949)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq3, scope.row.jjZs3)))])]
      }
    }], null, false, 3232757789)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "四",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq4, scope.row.jjZs4)))])]
      }
    }], null, false, 109898941)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq5, scope.row.jjZs5)))])]
      }
    }], null, false, 794447453)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "六",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq6, scope.row.jjZs6)))])]
      }
    }], null, false, 4244965373)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "七",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq7, scope.row.jjZs7)))])]
      }
    }], null, false, 2386965917)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "八",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq8, scope.row.jjZs8)))])]
      }
    }], null, false, 3274813501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "九",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq9, scope.row.jjZs9)))])]
      }
    }], null, false, 3959362013)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "十",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterNumHour(scope.row.jjXq10, scope.row.jjZs10)))])]
      }
    }], null, false, 4013568861)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjBz))])]
      }
    }], null, false, 4172767646)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "elrowStyle"
  }, [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [(_vm.jxjcForm.jjBglx == '2') ? _c('el-form-item', {
    attrs: {
      "label": "新课程信息:"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jxjcForm.jjBglx != '2') ? _c('el-form-item', {
    attrs: {
      "label": "课程信息:"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "jjKclx"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择课程类别",
      "filterable": ""
    },
    on: {
      "change": _vm.coursePropertiesChange
    },
    model: {
      value: (_vm.newJxjcForm.jjKclx),
      callback: function($$v) {
        _vm.$set(_vm.newJxjcForm, "jjKclx", $$v)
      },
      expression: "newJxjcForm.jjKclx"
    }
  }, _vm._l((_vm.kclxInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.newJxjcForm[0].jjKclxmc))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程属性",
      "prop": "jjKcsx"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择课程属性",
      "filterable": ""
    },
    on: {
      "change": _vm.coursePropertiesChange
    },
    model: {
      value: (_vm.newJxjcForm.jjKcsx),
      callback: function($$v) {
        _vm.$set(_vm.newJxjcForm, "jjKcsx", $$v)
      },
      expression: "newJxjcForm.jjKcsx"
    }
  }, _vm._l((_vm.kcsxInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.newJxjcForm[0].jjKcsxmc))])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "jjKcdm"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow != 'show'),
      expression: "this.jxjcShow != 'show'"
    }],
    staticClass: "input-full",
    attrs: {
      "placeholder": "请选择课程",
      "filterable": ""
    },
    on: {
      "change": _vm.courseInfoChange
    },
    model: {
      value: (_vm.newJxjcForm.jjKcdm),
      callback: function($$v) {
        _vm.$set(_vm.newJxjcForm, "jjKcdm", $$v)
      },
      expression: "newJxjcForm.jjKcdm"
    }
  }, _vm._l((_vm.courseInfo), function(item, index) {
    return _c('el-option', {
      key: item.jjKcdm,
      attrs: {
        "label": item.courseName,
        "value": item.jjKcdm
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.jxjcShow == 'show'),
      expression: "this.jxjcShow == 'show'"
    }]
  }, [_vm._v(_vm._s(_vm.newJxjcForm[0].jjKcmc))])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    ref: "CAPTable",
    staticClass: "tb-edit",
    staticStyle: {
      "width": "1622px"
    },
    attrs: {
      "data": _vm.newJxjcForm,
      "header-cell-style": {
        'text-align': 'center',
        'blackground-color': '#f1faf6'
      },
      "element-loading-text": "信息加载中",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "137px",
      "row-style": {
        'height': '64px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "学分",
      "width": "70",
      "align": "center",
      "prop": "score"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXf))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总学时",
      "width": "70",
      "align": "center",
      "prop": "totalTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjZxs))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "理论教学",
      "width": "70",
      "prop": "theoryTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjLljx))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实验实训",
      "width": "70",
      "prop": "practiseTime",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjSysx))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否专业\n核心课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isMajorcore))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '是否考证\n课程',
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.isCertificate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考核方式",
      "width": "80",
      "prop": "examType",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjKhfsmc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "二",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq2))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "三",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq3))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "四",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq4))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq5))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "六",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq6))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "七",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq7))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "八",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq8))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "九",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq9))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "十",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjXq10))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.jjBz))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "教学进程表",
      "custom-class": "teachingSchemeSetDialog",
      "width": "1860px",
      "top": "60px",
      "visible": _vm.showSchemeDialogVisivle
    },
    on: {
      "update:visible": function($event) {
        _vm.showSchemeDialogVisivle = $event
      },
      "closed": _vm.closeShowSchemeDialog
    }
  }, [_c('div', {
    staticClass: "maskStyle",
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "id": "loadingMask_edit"
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("教学进程表加载中，请稍候...")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "titles",
    staticStyle: {
      "text-align": "center",
      "height": "60px",
      "line-height": "60px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.queryForm.jpXn + '学年 ' + _vm.jpZymc) + " 教学进程表\n            ")]), _vm._v(" "), _c('el-row', [_c('editCAP', {
    ref: "editCAP",
    attrs: {
      "courseComboInfo": _vm.courseComboInfo,
      "editDisableState": _vm.editDisableState
    },
    on: {
      "changeEditRow": _vm.changeEditRow,
      "getJxjcInfo": _vm.getJxjcInfo,
      "closeJxjcInfoDialog": _vm.closeJxjcInfoDialog
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "复制",
      "visible": _vm.sduplicateDialogVisible,
      "width": "600px",
      "top": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.sduplicateDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "sduplicateForm",
    attrs: {
      "model": _vm.sduplicateForm,
      "label-width": "120px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.sduplicateRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "复制方案",
      "prop": "sorigin"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择目标方案",
      "filterable": ""
    },
    model: {
      value: (_vm.sduplicateForm.sorigin),
      callback: function($$v) {
        _vm.$set(_vm.sduplicateForm, "sorigin", $$v)
      },
      expression: "sduplicateForm.sorigin"
    }
  }, _vm._l((_vm.sorigins), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "目标学年",
      "prop": "starget"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请选择目标学年"
    },
    model: {
      value: (_vm.sduplicateForm.starget),
      callback: function($$v) {
        _vm.$set(_vm.sduplicateForm, "starget", $$v)
      },
      expression: "sduplicateForm.starget"
    }
  }, _vm._l((_vm.year), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sduplicate()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.sduplicateDialogCancel
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量复制",
      "visible": _vm.mduplicateDialogVisible,
      "width": "550px",
      "top": "250px"
    },
    on: {
      "update:visible": function($event) {
        _vm.mduplicateDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "mduplicateForm",
    attrs: {
      "model": _vm.mduplicateForm,
      "label-width": "130px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.mduplicateRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "复制学年",
      "prop": "morigin"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请选择起始学年"
    },
    on: {
      "change": _vm.hanleMoriginChange
    },
    model: {
      value: (_vm.mduplicateForm.morigin),
      callback: function($$v) {
        _vm.$set(_vm.mduplicateForm, "morigin", $$v)
      },
      expression: "mduplicateForm.morigin"
    }
  }, _vm._l((_vm.year), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "目标学年",
      "prop": "mtarget"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请选择目标学年"
    },
    model: {
      value: (_vm.mduplicateForm.mtarget),
      callback: function($$v) {
        _vm.$set(_vm.mduplicateForm, "mtarget", $$v)
      },
      expression: "mduplicateForm.mtarget"
    }
  }, _vm._l((_vm.year), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majors"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请选择专业（不选默认复制全部专业）",
      "multiple": ""
    },
    model: {
      value: (_vm.mduplicateForm.majors),
      callback: function($$v) {
        _vm.$set(_vm.mduplicateForm, "majors", $$v)
      },
      expression: "mduplicateForm.majors"
    }
  }, _vm._l((_vm.majors), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mduplicate()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.mduplicateDialogCancel
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), (_vm.auditDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核",
      "visible": _vm.auditDialogVisible,
      "width": "900px",
      "top": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData.jpBh,
      "auditLevel": _vm.selectRowData.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.jpBh,
      "listHeight": 450,
      "auditFlowInfo": _vm.auditFlowInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.coursePreConfigDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "公共课设置",
      "visible": _vm.coursePreConfigDialogVisible,
      "width": "1300px",
      "top": "50px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.coursePreConfigDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "700px"
    }
  }, [_c('coursePreConfig', {
    ref: "coursePreConfig",
    attrs: {
      "listHeight": 600
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.courseImportDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.courseImportDialogTitle,
      "visible": _vm.courseImportDialogVisible,
      "width": "1100px",
      "top": "100px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.courseImportDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "600px"
    }
  }, [_c('courseImport', {
    ref: "courseImport",
    attrs: {
      "listHeight": 520
    },
    on: {
      "refreshInfo": _vm.refreshInfo,
      "closeImportPubCourseDialog": _vm.closeImportPubCourseDialog
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出",
      "visible": _vm.exportDialogVisible,
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.exportDialogVisible = $event
      },
      "close": _vm.exportDialogVisibleClose
    }
  }, [_c('el-form', {
    ref: "exportForm",
    attrs: {
      "model": _vm.exportForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.yearStr),
      callback: function($$v) {
        _vm.yearStr = $$v
      },
      expression: "yearStr"
    }
  }, _vm._l((_vm.year), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属系部",
      "prop": "dept"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDept
    },
    model: {
      value: (_vm.dept),
      callback: function($$v) {
        _vm.dept = $$v
      },
      expression: "dept"
    }
  }, _vm._l((_vm.comboOption.dept), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属专业",
      "prop": "major"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.major),
      callback: function($$v) {
        _vm.major = $$v
      },
      expression: "major"
    }
  }, _vm._l((_vm.comboOption.major), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fileExport
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.exportDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.importDialogVisible,
      "width": "400px",
      "top": _vm.topHeight,
      "append-to-body": true,
      "bottom": "200px"
    },
    on: {
      "update:visible": function($event) {
        _vm.importDialogVisible = $event
      },
      "closed": _vm.closeImportDialog
    }
  }, [_c('div', {
    staticClass: "maskStyle",
    attrs: {
      "id": "loadingMask_import"
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("学分详情查询中，请稍候...")])]), _vm._v(" "), _c('div', {
    staticClass: "importDiv"
  }, [_c('el-upload', {
    ref: "fileupload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "show-file-list": false,
      "multiple": false,
      "auto-upload": true,
      "http-request": _vm.importTeachingProgress,
      "before-upload": _vm.beforeUpload,
      "limit": 100,
      "on-exceed": _vm.handleExceed,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip importTips",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("仅可导入xls/xlsx文件")])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '错误信息',
      "width": "400px",
      "top": _vm.topHeight,
      "visible": _vm.errorDialogVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.errorDialogVisible = $event
      },
      "closed": _vm.closeErrorDialog
    }
  }, [_c('div', {
    staticClass: "errorDiv",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  })]), _vm._v(" "), (_vm.progressStatisticsDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "课程类型统计",
      "visible": _vm.progressStatisticsDialogVisible,
      "width": "900px",
      "top": "110px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.progressStatisticsDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "610px"
    }
  }, [_c('progressStatistics', {
    ref: "progressStatistics",
    attrs: {
      "listHeight": 520,
      "ksnf": _vm.ksnf,
      "zydm": _vm.zydm,
      "xz": _vm.xz
    },
    on: {
      "closeProgressStatisticsDialog": _vm.closeProgressStatisticsDialog
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "继承专业课",
      "visible": _vm.inheritCourseDialog,
      "width": "540px",
      "top": "20vh",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.inheritCourseDialog = $event
      },
      "closed": _vm.closeInheritCourseDialog
    }
  }, [_c('el-form', {
    ref: "inheritForm",
    attrs: {
      "model": _vm.inheritForm,
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "被继承学年",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "学年"
    },
    model: {
      value: (_vm.inheritForm.year),
      callback: function($$v) {
        _vm.$set(_vm.inheritForm, "year", $$v)
      },
      expression: "inheritForm.year"
    }
  }, _vm._l((_vm.jcyear), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.inheritCourseSubmit
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }, [_vm._v(" 确定")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeInheritCourseDialog
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb13890c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/teachingScheme.vue
// module id = 1897
// module chunks = 502